export default {
  path: '/quote',
  component: () => import(/* webpackChunkName: 'quote' */'@/views/contract/layout/index'),
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      name: 'quoteIndex',
      component: () => import(/* webpackChunkName: 'quote' */'@/views/quote/index')
    },
    {
      path: '/quote/edit',
      name: 'quoteEdit',
      component: () => import(/* webpackChunkName: 'quote' */'@/views/quote/edit')
    },
    {
      path: '/quote/letter',
      name: 'quoteLetter',
      component: () => import(/* webpackChunkName: 'quote' */'@/views/quote/letter')
    },
    {
      path: '/quote/flow',
      name: 'quoteFlow',
      component: () => import(/* webpackChunkName: 'quote' */'@/views/quote/flow')
    }
  ]
}
